/**
 * Checks if the current pathname matches the target path feature,
 * accounting for base URL prefixes (e.g., "/tellescope2/" in staging).
 *
 * @param currentPathname - The current location pathname (may include base URL)
 * @param currentSearch - The current location search string
 * @param targetPath - The target path to compare against (app-relative)
 * @returns Whether the current location is within the same feature as the target path
 */
export const checkIsCurrentFeature = (currentPathname: string, currentSearch: string, targetPath: string): boolean => {
  if (!currentSearch) return false;

  // Extract the app-relative path by removing any base URL prefix
  // In staging, currentPathname might be "/tellescope2/messaging/inbox"
  // while targetPath is "/messaging/inbox"
  // Find where targetPath appears in currentPathname to get the app-relative portion
  const normalizedTargetPath = targetPath.startsWith("/") ? targetPath.slice(1) : targetPath;
  const targetIndex = currentPathname.indexOf(normalizedTargetPath);
  const normalizedCurrentPathname =
    targetIndex >= 0
      ? currentPathname.slice(targetIndex)
      : currentPathname.startsWith("/")
      ? currentPathname.slice(1)
      : currentPathname;

  const currentSegments = normalizedCurrentPathname.split("/");
  const newSegments = normalizedTargetPath.split("/");
  const matchingSegments = currentSegments.reduce<number>((acc, curr, i) => {
    if (curr === newSegments[i]) {
      acc++;
    }
    return acc;
  }, 0);
  return normalizedCurrentPathname.includes("messaging") ? matchingSegments > 1 : !!matchingSegments;
};
